import {ContentUserProductionParticipantDomain} from "../../domain/content/ContentUserProductionParticipantDomain"
import {ContentUserProductionParticipantId} from "../../id/content/ContentUserProductionParticipantId"
import {UserId} from "../../id/user/UserId"
import {ValueObject} from "ts-protocol-extension"

/**
 * 와글와글 인원 프리셋
 */
export class ContentUserProductionParticipantValueObject implements ValueObject, ContentUserProductionParticipantDomain {
    /**
     * 기본키
     */
    id: ContentUserProductionParticipantId
    /**
     * 생성자 ID
     */
    creatorId: UserId
    /**
     * 인원
     */
    value: number
    /**
     * 표시 순서
     */
    displayOrder: number
    /**
     * 생성일
     */
    createdAt: Date
    /**
     * 마지막 수정일
     */
    lastModifiedAt?: Date

    constructor(o: Record<keyof ContentUserProductionParticipantDomain, any>) {
        this.id = BigInt(o.id)
        this.creatorId = BigInt(o.creatorId)
        this.value = Number(o.value)
        this.displayOrder = Number(o.displayOrder)
        this.createdAt = new Date(o.createdAt)
        if (o.lastModifiedAt !== undefined && o.lastModifiedAt !== null) {
            this.lastModifiedAt = new Date(o.lastModifiedAt)
        }
    }
}
